/**
 * Authentication configuration
 * Centralized configuration for auth-related settings
 */

export const AUTH_CONFIG = {
  // Token refresh settings (sliding session while BackOffice is in use)
  REFRESH_THRESHOLD: 5 * 60, // Refresh JWT 5 minutes before expiry
  REFRESH_RETRY_ATTEMPTS: 3,
  REFRESH_RETRY_DELAY: 1000, // 1 second
  // Backend: GET /api/Auth/RefreshToken?token=<accessJwt> issues a new 24h JWT
  ACCESS_TOKEN_EXPIRY: 3 * 60 * 60, // default login without Keep Me Login (3 hours)
  KEEP_ME_LOGIN_TOKEN_EXPIRY: 200 * 60 * 60, // Keep Me Login (200 hours)
  REFRESHED_TOKEN_EXPIRY: 24 * 60 * 60, // after successful refresh (24 hours)

  // Cookie settings (for future httpOnly implementation)
  COOKIE_SETTINGS: {
    SECURE: true,
    SAME_SITE: 'strict',
    PATH: '/',
    DOMAIN: process.env.REACT_APP_COOKIE_DOMAIN || undefined,
  },

  // Storage settings
  STORAGE_TYPE: 'localStorage',

  // Security settings
  AUTO_LOGOUT_ON_EXPIRY: true,
  CHECK_TOKEN_ON_VISIBILITY_CHANGE: true,
  CHECK_TOKEN_ON_STORAGE_CHANGE: true,
  PERIODIC_TOKEN_CHECK: 5 * 60 * 1000, // Check every 5 minutes

  // API endpoints
  ENDPOINTS: {
    LOGIN: '/api/Auth/LoginBackOffice',
    REFRESH: '/api/Auth/RefreshToken',
    LOGOUT: '/api/Auth/Logout',
    VALIDATE: '/api/Auth/ValidateToken',
  },

  // Error handling
  ERROR_CODES: {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    TOKEN_EXPIRED: 401,
    INVALID_TOKEN: 401,
  },

  // Redirect settings (post-login path resolution: utils/authRedirect.js)
  REDIRECTS: {
    LOGIN: '/user/login',
    DASHBOARD: '/dashboard',
    UNAUTHORIZED: '/unauthorized',
    RETURN_URL_PARAM: 'returnUrl',
    SESSION_EXPIRED: '/user/login?expired=true',
  },

  // Feature flags
  FEATURES: {
    TOKEN_REFRESH: true,
    HTTP_ONLY_COOKIES: false, // Set to true when backend supports it
    ROLE_BASED_ACCESS: false, // Set to true when implementing RBAC
    MULTI_TAB_SYNC: true,
    REMEMBER_ME: true,
  },
};

// Environment-specific overrides
if (process.env.NODE_ENV === 'development') {
  AUTH_CONFIG.COOKIE_SETTINGS.SECURE = false; // Allow HTTP in development
  AUTH_CONFIG.FEATURES.HTTP_ONLY_COOKIES = true; // Use localStorage in development
}

if (process.env.NODE_ENV === 'production') {
  AUTH_CONFIG.COOKIE_SETTINGS.SECURE = true; // Require HTTPS in production
  AUTH_CONFIG.FEATURES.HTTP_ONLY_COOKIES = true; // Enable httpOnly in production
}

export default AUTH_CONFIG;
